// Application configuration
const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? '', // Empty string = relative URL (same origin in production)
};

export default config;
